export default "__VITE_ASSET__e88023a1__"